import type { ReactElement } from 'react';
import React from 'react';

import { css } from '@emotion/react';
import {
  type Button,
  Heading,
  Primitive,
  Text,
  VStack,
} from '@rtkwlf/fenrir-react';

import { useDocumentTitle } from '@packages/fenrir/hooks/use-document-title';

export const textColor = '#ffffff';
const warningColor = '#f58220';

const textCss = css({
  color: textColor,
  whiteSpace: 'pre-line',
});

const headerCss = css({
  color: warningColor,
  textDecoration: 'none',
});

export const linkCss = css({
  color: warningColor,
});

type PageNotFoundProps = {
  title: string;
  Icon: ReactElement;
  Button?: ReactElement<typeof Button>;
  backgroundImage: string;
  'data-testid'?: string;
};

const ErrorPage = ({
  title,
  children,
  Icon,
  Button,
  backgroundImage,
  'data-testid': dataTestId,
}: React.PropsWithChildren<PageNotFoundProps>) => {
  useDocumentTitle(title);

  const backgroundImageCss = css({
    backgroundImage,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    height: '100%',
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%',
  });

  return (
    <Primitive.div css={backgroundImageCss} data-testid={dataTestId}>
      <VStack xAlign="center" yAlign="center" height="full" gap="xlarge">
        {Icon}
        <Heading css={headerCss} textAlign="center" level="1">
          {title}
        </Heading>
        <Text textAlign="center" css={textCss}>
          {children}
        </Text>
        {Button}
      </VStack>
    </Primitive.div>
  );
};

export default ErrorPage;
